import React from "react";
import BlogDetailsCard from "../../componets/BlogDetailsCard/BlogDetailsCard";

const Section2 = () => {
  return (
    <div className="mt-[50px] flex justify-center items-center">
      <div className="container-1280 mx-4 sm:mx-8 md:mx-16 lg:mx-24 ">
        <BlogDetailsCard />
      </div>
    </div>
  );
};

export default Section2;
